import { FC } from 'react'
import { RescheduleOrderController } from './RescheduleOrder.controller'
import { ThemeProvider } from '@mui/material'
import { redesignMUITheme } from 'constants/styling/redesignTheme'

export const RescheduleOrder: FC = () => {
  return (
    <ThemeProvider theme={redesignMUITheme}>
      <RescheduleOrderController />
    </ThemeProvider>
  )
}
